<sb-modal-template [templateId]="templateId">
  <div modal-header>
    <h5 class="modal-title" *ngIf="options.title">{{ options.title }}</h5>
  </div>
  <div modal-body>
    <ng-content select="[slot=body]">
    </ng-content>
  </div>
  <div modal-footer>
    <ng-content select="[slot=footer]">
    </ng-content>
  </div>
</sb-modal-template>
